/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { ProductNameContext } from "../context";

function SEO({ description, lang, meta, title, image, type }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  );

  type = type || "website";

  const metaDescription = description || site.siteMetadata.description;

  const titleTemplate = title ? `%s | ${site.siteMetadata.title}` : `%s`;
  title = title || site.siteMetadata.title;

  image = `${site.siteMetadata.siteUrl}${
    image || require("../../../images/description-image.jpg")
  }`;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={titleTemplate}
      defer={false}
      meta={[
        {
          name: `slack-app-id`,
          content: process.env.SLACK_APP_ID,
        },
        {
          property: `og:title`,
          name: `title`,
          content: title,
        },
        {
          property: `og:type`,
          content: type,
        },
        {
          name: "description",
          property: `og:description`,
          content: metaDescription,
        },
        // {
        //   property: `og:url`,
        //   content: site.siteMetadata.siteUrl,
        // },
        {
          property: `og:site_name`,
          content: "Remeet",
        },
        {
          name: "image",
          property: `og:image`,
          content: image,
        },
        /* twitter card */
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: "RemeetHQ",
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        // {
        //   name: `twitter:site`,
        //   content: site.siteMetadata.siteUrl,
        // },
        {
          name: `twitter:image`,
          content: image,
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};

export default SEO;
